import React, {useState, useCallback, useEffect} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation, useLazyQuery } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import { View } from 'react-native';
import { RECURRING_SALE, UPDATE_RECURRING_SALE } from './queries';
import { ButtonContainer } from './elements';
import moment from 'moment';
import { formatDateForInput, formatTimeForInput } from '../../../utils/timeFormatter';
import { DAYS_OF_WEEK } from '.';

const EditRecurringSale = ({setShowModal, refetch, recurringSale}) => {
  const [submitting, setSubmitting] = useState();
  const [updateRecurringSale] = useMutation(UPDATE_RECURRING_SALE, {
    onCompleted: () => {
      refetch();
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    input['frequency'] = parseInt(input['frequency']);
    input['dayOfWeek'] = parseInt(input['dayOfWeek']);
    input['weekOfMonth'] = parseInt(input['weekOfMonth']);
    input['preBidDaysAhead'] = parseInt(input['preBidDaysAhead']);
    input['createDaysAhead'] = parseInt(input['createDaysAhead']);
    updateRecurringSale({ variables: input });
  });

  // const [ loadRecurringSale, { loading: loading, data: data } ] =
  // useLazyQuery(RECURRING_SALE, {onCompleted: refetch});

  // if (recurringSale === undefined && id && !loading) {
  //   loadRecurringSale({ variables: { id } });
  // }

  const { control, handleSubmit, register, watch, formState: { errors } } = useForm({
    defaultValues: {
      id: recurringSale?.id,
      name: recurringSale?.name || '',
      recurrence: recurringSale?.recurrence || '',
      frequency: parseInt(recurringSale?.frequency) || '',
      dayOfWeek: parseInt(recurringSale?.dayOfWeek) || '',
      weekOfMonth: parseInt(recurringSale?.weekOfMonth) || '',
      preBidOpenAt: formatTimeForInput(recurringSale?.preBidOpenAt) || '',
      preBidDaysAhead: parseInt(recurringSale?.preBidDaysAhead) || '',
      createDaysAhead: parseInt(recurringSale?.createDaysAhead) || '',
      startAt: formatTimeForInput(recurringSale?.startAt) || '',
      endAt: formatTimeForInput(recurringSale?.endAt) || '',
      startOn: formatDateForInput(recurringSale?.startOn) || ''
    }
  });

  const watchRecurrence = watch('recurrence');

  return (
    <View>
      {submitting ?
        DataState.Loading :
        <View>
          <Input.Text
            label="Name:"
            name="name"
            control={control}
            errors={errors}
          />
          <Input.Picker
            label="Recurrence:"
            name="recurrence"
            control={control}
            errors={errors}
            options={['weekly', 'monthly'].map(option => {
              return {value: option, label: option}
            })}
          />
          <Input.Number
            label="Frequency:"
            name="frequency"
            control={control}
            errors={errors}
          />
          <Input.Picker
            label="Day of Week:"
            name="dayOfWeek"
            control={control}
            errors={errors}
            options={DAYS_OF_WEEK.map(option => {
              return option
            })}
          />
          {'monthly' === watchRecurrence && (
            <Input.Number
              label="Week of Month:"
              name="weekOfMonth"
              control={control}
              errors={errors}
            />
          )}
          <Input.Time
            label="Pre Bid Open At:"
            name="preBidOpenAt"
            control={control}
            errors={errors}
          />
          <Input.Number
            label="PreBid Days Ahead:"
            name="preBidDaysAhead"
            control={control}
            errors={errors}
          />
          <Input.Number
            label="Create Days Ahead:"
            name="createDaysAhead"
            control={control}
            errors={errors}
          />
          <Input.Time
            label="Start:"
            name="startAt"
            control={control}
            errors={errors}
          />
          <Input.Time
            label="End:"
            name="endAt"
            control={control}
            errors={errors}
          />
          <Input.Date
            label="Start On:"
            name="startOn"
            control={control}
            errors={errors}
          />
          <ButtonContainer>
            <ButtonGroup>
              <Button label="Update Sale" onPress={handleSubmit(onSubmit)} />
            </ButtonGroup>
          </ButtonContainer>
        </View>
      }
    </View>
  )
}

export default EditRecurringSale;
